// import React, { useEffect, useState } from "react";
// import {
//   Grid,
//   Typography,
//   Paper,
//   Box,
//   Button,
//   Chip,
//   Divider,
//   Stack,
//   Avatar,
//   CircularProgress,
//   alpha,
// } from "@mui/material";
// import { useParams, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import swal from "sweetalert";
// import MainCard from "ui-component/cards/MainCard";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import CancelIcon from "@mui/icons-material/Cancel";
// import PendingActionsIcon from "@mui/icons-material/PendingActions";
// import PersonIcon from "@mui/icons-material/Person";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// const VehicleGatePassDetails = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const API = process.env.REACT_APP_API_URL;
//   const AUTH_KEY = process.env.REACT_APP_AUTH_KEY;

//   const [vehiclePass, setVehiclePass] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [updatingStatus, setUpdatingStatus] = useState(false);
//   const [sendingPass, setSendingPass] = useState(false);

//   // --- Helpers ---
//   const formatDate = (date) => {
//     if (!date) return "-";
//     return new Date(date).toLocaleString("en-IN", {
//       day: "numeric",
//       month: "short",
//       year: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   const getStatusChip = (status) => {
//     const commonStyles = {
//       fontWeight: 500,
//       px: 1.5,
//       py: 0.5,
//       borderRadius: "12px",
//       fontSize: "0.8rem",
//     };
//     switch (status) {
//       case "accept":
//         return (
//           <Chip
//             icon={<CheckCircleIcon />}
//             label="Accepted"
//             sx={{
//               ...commonStyles,
//               backgroundColor: alpha("#4caf50", 0.15),
//               color: "#2e7d32",
//             }}
//           />
//         );
//       case "reject":
//         return (
//           <Chip
//             icon={<CancelIcon />}
//             label="Rejected"
//             sx={{
//               ...commonStyles,
//               backgroundColor: alpha("#f44336", 0.15),
//               color: "#b71c1c",
//             }}
//           />
//         );
//       default:
//         return (
//           <Chip
//             icon={<PendingActionsIcon />}
//             label="Pending"
//             sx={{
//               ...commonStyles,
//               backgroundColor: alpha("#ffeb3b", 0.25),
//               color: "#7c6f00",
//             }}
//           />
//         );
//     }
//   };

//   const openDocument = (url) => {
//     if (url) {
//       window.open(url, "_blank");
//     }
//   };

//   // --- API calls ---
//   const fetchVehiclePass = async () => {
//     try {
//       const response = await fetch(`${API}vehicle-gate-pass-details/${id}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           authkey: AUTH_KEY,
//         },
//       });
//       const data = await response.json();
//       if (response.ok && data?.data?.vehiclePass) {
//         setVehiclePass(data.data.vehiclePass);
//       } else {
//         toast.error("Failed to fetch vehicle pass details");
//         navigate(-1);
//       }
//     } catch (error) {
//       toast.error("Something went wrong while fetching details");
//       navigate(-1);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const updateVehiclePassStatus = async (passId, action, fullName) => {
//     const actionText = action === "accept" ? "Accept" : "Reject";
//     const confirm = await swal({
//       title: `${actionText} ${fullName}?`,
//       text: `Are you sure you want to ${actionText.toLowerCase()} this Vehicle pass?`,
//       icon: action === "accept" ? "success" : "error",
//       buttons: ["Cancel", actionText],
//       dangerMode: action === "reject",
//     });

//     if (!confirm) return;

//     try {
//       setUpdatingStatus(true);
//       const response = await fetch(`${API}update-vehicle-gate-pass-status/${passId}`, {
//         method: "PUT",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           authkey: AUTH_KEY,
//         },
//         body: JSON.stringify({ status: action }),
//       });

//       const data = await response.json();
//       if (response.ok) {
//         toast.success(`Vehicle pass ${action === "accept" ? "accepted" : "rejected"} successfully`);
//         setVehiclePass((prev) => ({ ...prev, status: action }));
//       } else {
//         toast.error(data.message || "Failed to update status");
//       }
//     } catch (error) {
//       toast.error("Error updating status");
//     } finally {
//       setUpdatingStatus(false);
//     }
//   };

//   const sendVehicleGatePass = async (passId, fullName) => {
//     try {
//       setSendingPass(true);
//       const response = await fetch(`${API}send-vehicle-gate-pass/${passId}`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           authkey: AUTH_KEY,
//         },
//       });
//       const data = await response.json();
//       if (response.ok) {
//         toast.success(`Gate pass sent to ${fullName}`);
//       } else {
//         toast.error(data.message || "Failed to send gate pass");
//       }
//     } catch (error) {
//       toast.error("Error sending gate pass");
//     } finally {
//       setSendingPass(false);
//     }
//   };

//   useEffect(() => {
//     fetchVehiclePass();
//     // eslint-disable-next-line
//   }, [id, updatingStatus]);

//   if (loading)
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" height="70vh">
//         <CircularProgress />
//       </Box>
//     );

//   if (!vehiclePass)
//     return (
//       <Typography textAlign="center" variant="h6" color="text.secondary">
//         No details found.
//       </Typography>
//     );

//   const {
//     _id,
//     email,
//     companyName,
//     fullName,
//     nationality,
//     idIqama,
//     vehicles,
//     reasonOfVisit,
//     visitStart,
//     visitEnd,
//     visitingAreas,
//     department,
//     staff,
//     contactPerson,
//     isdManager,
//     idStickerOfficeSignature,
//     signatureDate,
//     documents,
//     qrCode,
//     status,
//     scanHistory,
//     createdAt,
//     updatedAt,
//     visitorId,
//   } = vehiclePass;

//   return (
//     <MainCard>
//       <Grid container spacing={3}>
//         {/* Header */}
//         <Grid item xs={12}>
//           <Box
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               mb: 2,
//             }}
//           >
//             <Stack direction="row" spacing={2} alignItems="center">
//               <Avatar sx={{ bgcolor: "primary.main", color: "#fff", width: 60, height: 60 }}>
//                 {fullName ? fullName.charAt(0).toUpperCase() : "U"}
//               </Avatar>
//               <Box>
//                 <Typography variant="h5" sx={{ fontWeight: 600, textTransform: "capitalize" }}>
//                   {fullName}
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary">
//                   {visitorId || "-"}
//                 </Typography>
//               </Box>
//             </Stack>
//             {getStatusChip(status)}
//           </Box>
//         </Grid>

//         {/* Visitor & Company Information */}
//         <Grid item xs={12}>
//           <Paper
//             sx={{
//               border: "1px solid #2196f3",
//               backgroundColor: "#f9fbff",
//               borderRadius: 2,
//               p: 2.5,
//             }}
//           >
//             <Stack direction="row" spacing={1} alignItems="center" mb={1}>
//               <PersonIcon color="primary" />
//               <Typography variant="subtitle1" fontWeight={600}>
//                 Visitor & Company Information
//               </Typography>
//             </Stack>
//             <Divider sx={{ mb: 2 }} />

//             <Grid container spacing={2}>
//               <Grid item xs={12} sm={6}>
//                 <Stack spacing={1}>
//                   <Typography>
//                     <b>Full Name:</b> {fullName || "-"}
//                   </Typography>
//                   <Typography>
//                     <b>Email:</b> {email || "-"}
//                   </Typography>
//                   <Typography>
//                     <b>Company:</b> {companyName || "-"}
//                   </Typography>
//                   <Typography>
//                     <b>Nationality:</b> {nationality || "-"}
//                   </Typography>
//                 </Stack>
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <Stack spacing={1}>
//                   <Typography>
//                     <b>ID / Iqama:</b> {idIqama || "-"}
//                   </Typography>
//                   <Typography>
//                     <b>Contact Person:</b> {contactPerson || "-"}
//                   </Typography>
//                   <Typography>
//                     <b>Visitor ID:</b> {visitorId || "-"}
//                   </Typography>
//                 </Stack>
//               </Grid>
//             </Grid>
//           </Paper>
//         </Grid>

//         {/* Vehicle Information */}
//         {vehicles?.length > 0 && (
//           <Grid item xs={12}>
//             <Paper
//               sx={{
//                 border: "1px solid #e0e0e0",
//                 backgroundColor: "#fff",
//                 borderRadius: 2,
//                 p: 2.5,
//               }}
//             >
//               <Typography variant="subtitle1" fontWeight={600} mb={1}>
//                 Vehicle Information
//               </Typography>
//               <Divider sx={{ mb: 2 }} />
//               {vehicles.map((vehicle, index) => (
//                 <Box
//                   key={vehicle._id || index}
//                   sx={{ mb: 2, p: 2, border: "1px solid #eee", borderRadius: 1 }}
//                 >
//                   <Typography variant="h6" mb={1}>
//                     Vehicle {index + 1}
//                   </Typography>
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} sm={3}>
//                       <Typography>
//                         <b>Name:</b> {vehicle.name || "-"}
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={12} sm={3}>
//                       <Typography>
//                         <b>Model:</b> {vehicle.model || "-"}
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={12} sm={3}>
//                       <Typography>
//                         <b>Color:</b> {vehicle.color || "-"}
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={12} sm={3}>
//                       <Typography>
//                         <b>Plate No:</b> {vehicle.plateNo || "-"}
//                       </Typography>
//                     </Grid>
//                     <Grid item xs={12}>
//                       <Typography>
//                         <b>Owner Name:</b> {vehicle.ownerName || "-"}
//                       </Typography>
//                     </Grid>
//                   </Grid>
//                 </Box>
//               ))}
//               <Typography>
//                 <b>Reason of Visit:</b> {reasonOfVisit || "-"}
//               </Typography>
//             </Paper>
//           </Grid>
//         )}

//         {/* Documents */}
//         <Grid item xs={12}>
//           <Paper
//             sx={{
//               border: "1px solid #9c27b0",
//               backgroundColor: "#f3e5f5",
//               borderRadius: 2,
//               p: 2.5,
//             }}
//           >
//             <Typography variant="subtitle1" fontWeight={600} mb={1}>
//               Documents
//             </Typography>
//             <Divider sx={{ mb: 2 }} />
//             <Grid container spacing={2}>
//               {Object.entries(documents || {}).map(([docType, doc]) => (
//                 <Grid item xs={12} sm={6} md={3} key={docType}>
//                   <Box>
//                     <Typography variant="body2" mb={1}>
//                       {docType.replace(/([A-Z])/g, " $1").trim()}:
//                     </Typography>
//                     {doc && doc.key ? (
//                       <Button
//                         variant="text"
//                         color="primary"
//                         onClick={() => openDocument(doc.url || doc.key)} // Assume url is provided, fallback to key if needed
//                         sx={{ textTransform: "none", justifyContent: "flex-start", p: 0 }}
//                       >
//                         <Typography variant="body2">
//                           <b>{doc.originalFileName || doc.key.split("/").pop()}</b>
//                         </Typography>
//                       </Button>
//                     ) : (
//                       <Typography variant="body2" color="text.secondary">
//                         No file
//                       </Typography>
//                     )}
//                   </Box>
//                 </Grid>
//               ))}
//             </Grid>
//           </Paper>
//         </Grid>

//         {/* Visit / Approval Information */}
//         <Grid item xs={12}>
//           <Paper
//             sx={{
//               border: "1px solid #e0e0e0",
//               backgroundColor: "#fff",
//               borderRadius: 2,
//               p: 2.5,
//             }}
//           >
//             <Stack direction="row" spacing={1} alignItems="center" mb={1}>
//               <CalendarMonthIcon color="primary" />
//               <Typography variant="subtitle1" fontWeight={600}>
//                 Visit & Approval Information
//               </Typography>
//             </Stack>
//             <Divider sx={{ mb: 2 }} />

//             <Grid container spacing={2}>
//               <Grid item xs={6}>
//                 <Typography>
//                   <b>Visit Start:</b>{" "}
//                   <span style={{ color: "#2e7d32" }}>{formatDate(visitStart)}</span>
//                 </Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography>
//                   <b>Visit End:</b> <span style={{ color: "#d32f2f" }}>{formatDate(visitEnd)}</span>
//                 </Typography>
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <Typography>
//                   <b>Department:</b> {department?.name || "-"}
//                 </Typography>
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <Typography>
//                   <b>Staff:</b> {staff || "-"}
//                 </Typography>
//               </Grid>
//               <Grid item xs={12}>
//                 <Typography>
//                   <b>Visiting Areas:</b> {visitingAreas || "-"}
//                 </Typography>
//               </Grid>
//             </Grid>
//           </Paper>
//         </Grid>

//         {/* QR Code */}
//         {qrCode?.url && (
//           <Grid item xs={12}>
//             <Paper
//               sx={{
//                 border: "1px solid #e0e0e0",
//                 backgroundColor: "#fff",
//                 borderRadius: 2,
//                 p: 2.5,
//                 textAlign: "center",
//               }}
//             >
//               <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" mb={1}>
//                 <img
//                   src={qrCode.url}
//                   alt="QR Code"
//                   style={{
//                     width: 160,
//                     height: 160,
//                     border: "1px solid #ddd",
//                     borderRadius: 12,
//                     backgroundColor: "#fff",
//                   }}
//                 />
//               </Stack>
//               <Typography variant="subtitle1" color="text.secondary">
//                 QR Code for Vehicle Gate Pass
//               </Typography>
//             </Paper>
//           </Grid>
//         )}

//         {/* Scan History */}
//         {scanHistory?.length > 0 && (
//           <Grid item xs={12}>
//             <Paper
//               sx={{
//                 border: "1px solid #e0e0e0",
//                 backgroundColor: "#fff",
//                 borderRadius: 2,
//                 p: 2.5,
//               }}
//             >
//               <Stack direction="row" spacing={1} alignItems="center" mb={1}>
//                 <Typography variant="subtitle1" fontWeight={600}>
//                   Scan History
//                 </Typography>
//               </Stack>
//               <Divider sx={{ mb: 2 }} />

//               <Box sx={{ overflowX: "auto" }}>
//                 <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                   <thead>
//                     <tr style={{ backgroundColor: "#f5f5f5" }}>
//                       <th style={{ padding: "8px", textAlign: "left" }}>Scan Time</th>
//                       <th style={{ padding: "8px", textAlign: "left" }}>Status Code</th>
//                       <th style={{ padding: "8px", textAlign: "left" }}>Validity</th>
//                       <th style={{ padding: "8px", textAlign: "left" }}>Reason</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {scanHistory.map((scan) => (
//                       <tr key={scan._id} style={{ borderBottom: "1px solid #eee" }}>
//                         <td style={{ padding: "8px" }}>{formatDate(scan.scanTime)}</td>
//                         <td style={{ padding: "8px" }}>{scan.statusCode || "-"}</td>
//                         <td style={{ padding: "8px" }}>
//                           {scan.isValid ? (
//                             <Chip label="Valid" color="success" size="small" />
//                           ) : (
//                             <Chip label="Invalid" color="error" size="small" />
//                           )}
//                         </td>
//                         <td style={{ padding: "8px" }}>{scan.reason || "-"}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </Box>
//             </Paper>
//           </Grid>
//         )}

//         {/* System Information */}
//         <Grid item xs={12}>
//           <Paper
//             sx={{
//               border: "1px solid #e0e0e0",
//               backgroundColor: "#fafafa",
//               borderRadius: 2,
//               p: 2,
//             }}
//           >
//             <Grid container spacing={2}>
//               <Grid item xs={6}>
//                 <Typography>
//                   <b>Created At:</b> {formatDate(createdAt)}
//                 </Typography>
//               </Grid>
//               <Grid item xs={6}>
//                 <Typography textAlign="right">
//                   <b>Last Updated:</b> {formatDate(updatedAt)}
//                 </Typography>
//               </Grid>
//             </Grid>
//           </Paper>
//         </Grid>

//         {/* Action Buttons */}
//         <Grid item xs={12}>
//           <Divider sx={{ mb: 2 }} />
//           <Stack direction="row" spacing={2} justifyContent="flex-start">
//             {status === "pending" && (
//               <>
//                 <Button
//                   variant="contained"
//                   sx={{
//                     backgroundColor: "#2e7d32",
//                     "&:hover": { backgroundColor: "#1b5e20" },
//                   }}
//                   disabled={updatingStatus}
//                   onClick={() => updateVehiclePassStatus(_id, "accept", fullName)}
//                 >
//                   {updatingStatus ? <CircularProgress size={20} color="inherit" /> : "Accept Pass"}
//                 </Button>

//                 <Button
//                   variant="contained"
//                   sx={{
//                     backgroundColor: "#d32f2f",
//                     "&:hover": { backgroundColor: "#b71c1c" },
//                   }}
//                   disabled={updatingStatus}
//                   onClick={() => updateVehiclePassStatus(_id, "reject", fullName)}
//                 >
//                   {updatingStatus ? <CircularProgress size={20} color="inherit" /> : "Reject Pass"}
//                 </Button>
//               </>
//             )}

//             {status === "accept" && (
//               <Button
//                 variant="contained"
//                 color="primary"
//                 disabled={sendingPass}
//                 onClick={() => sendVehicleGatePass(_id, fullName)}
//               >
//                 {sendingPass ? <CircularProgress size={20} color="inherit" /> : "Send Gate Pass"}
//               </Button>
//             )}

//             <Button
//               variant="outlined"
//               startIcon={<ArrowBackIcon />}
//               onClick={() => navigate(-1)}
//               sx={{ borderColor: "#1976d2", color: "#1976d2" }}
//             >
//               Back To List
//             </Button>
//           </Stack>
//         </Grid>
//       </Grid>
//     </MainCard>
//   );
// };

// export default VehicleGatePassDetails;

// import React, { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import swal from "sweetalert";
// import {
//   User,
//   Calendar,
//   Car,
//   FileText,
//   QrCode,
//   Clock,
//   ArrowLeft,
//   CheckCircle,
//   XCircle,
//   AlertCircle,
//   Mail,
//   Building,
//   IdCard,
//   Globe,
// } from "lucide-react";
// import styles from "./vehicleGatePassDetails.module.css";

// const VehicleGatePassDetails = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const API = process.env.REACT_APP_API_URL;
//   const AUTH_KEY = process.env.REACT_APP_AUTH_KEY;

//   const [vehiclePass, setVehiclePass] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [updatingStatus, setUpdatingStatus] = useState(false);
//   const [sendingPass, setSendingPass] = useState(false);

//   const formatDate = (date) => {
//     if (!date) return "-";
//     return new Date(date).toLocaleString("en-IN", {
//       day: "numeric",
//       month: "short",
//       year: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   const getStatusBadge = (status) => {
//     switch (status) {
//       case "accept":
//         return (
//           <div className={`${styles.badge} ${styles.badgeAccepted}`}>
//             <CheckCircle size={16} />
//             <span>Accepted</span>
//           </div>
//         );
//       case "reject":
//         return (
//           <div className={`${styles.badge} ${styles.badgeRejected}`}>
//             <XCircle size={16} />
//             <span>Rejected</span>
//           </div>
//         );
//       default:
//         return (
//           <div className={`${styles.badge} ${styles.badgePending}`}>
//             <AlertCircle size={16} />
//             <span>Pending</span>
//           </div>
//         );
//     }
//   };

//   const fetchVehiclePass = async () => {
//     try {
//       const response = await fetch(`${API}vehicle-gate-pass-details/${id}`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           authkey: AUTH_KEY,
//         },
//       });
//       const data = await response.json();
//       if (response.ok && data?.data?.vehiclePass) {
//         setVehiclePass(data.data.vehiclePass);
//       } else {
//         toast.error("Failed to fetch vehicle gate pass details");
//         navigate(-1);
//       }
//     } catch (error) {
//       toast.error("Something went wrong while fetching details");
//       navigate(-1);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const updateStatus = async (action, fullName) => {
//     const actionText = action === "accept" ? "Accept" : "Reject";

//     const confirm = await swal({
//       title: `${actionText} ${fullName}?`,
//       text: `Are you sure you want to ${actionText.toLowerCase()} this Vehicle pass?`,
//       icon: action === "accept" ? "success" : "error",
//       buttons: ["Cancel", actionText],
//       dangerMode: action === "reject",
//     });

//     if (!confirm) return;

//     try {
//       setUpdatingStatus(true);
//       const response = await fetch(
//         `${API}update-vehicle-gate-pass-status/${vehiclePass._id}`,
//         {
//           method: "PUT",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             authkey: AUTH_KEY,
//           },
//           body: JSON.stringify({ status: action }),
//         }
//       );
//       const data = await response.json();
//       if (response.ok) {
//         toast.success(`Pass ${action === "accept" ? "accepted" : "rejected"} successfully`);
//         setVehiclePass((prev) => ({ ...prev, status: action }));
//       } else {
//         toast.error(data.message || "Failed to update status");
//       }
//     } catch (error) {
//       toast.error("Error updating status");
//     } finally {
//       setUpdatingStatus(false);
//     }
//   };

//   const sendGatePass = async () => {
//     try {
//       setSendingPass(true);
//       const response = await fetch(`${API}send-vehicle-gate-pass/${vehiclePass._id}`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           authkey: AUTH_KEY,
//         },
//       });
//       const data = await response.json();
//       if (response.ok) {
//         toast.success(`Gate pass sent successfully`);
//       } else {
//         toast.error(data.message || "Failed to send gate pass");
//       }
//     } catch (error) {
//       toast.error("Error sending gate pass");
//     } finally {
//       setSendingPass(false);
//     }
//   };

//   useEffect(() => {
//     fetchVehiclePass();
//   }, [id, updatingStatus]);

//   if (loading) {
//     return (
//       <div className={styles.loadingContainer}>
//         <div className={styles.spinner}></div>
//       </div>
//     );
//   }

//   if (!vehiclePass) {
//     return (
//       <div className={styles.noData}>
//         <p>No details found.</p>
//       </div>
//     );
//   }

//   const {
//     fullName,
//     email,
//     companyName,
//     nationality,
//     idIqama,
//     vehicles,
//     reasonOfVisit,
//     visitStart,
//     visitEnd,
//     visitingAreas,
//     department,
//     staff,
//     contactPerson,
//     documents,
//     qrCode,
//     status,
//     scanHistory,
//     createdAt,
//     updatedAt,
//     visitorId,
//   } = vehiclePass;

//   return (
//     <div className={styles.container}>
//       {/* Header Section */}
//       <div className={styles.header}>
//         <div className={styles.headerLeft}>
//           <div className={styles.avatar}>
//             {fullName ? fullName.charAt(0).toUpperCase() : "V"}
//           </div>
//           <div className={styles.headerInfo}>
//             <h1 className={styles.title}>{fullName || "Vehicle Pass"}</h1>
//             <div className={styles.metaInfo}>
//               <span className={styles.metaItem}>
//                 <IdCard size={14} />
//                 {visitorId || "N/A"}
//               </span>
//               <span className={styles.metaItem}>
//                 <Building size={14} />
//                 {companyName || "N/A"}
//               </span>
//             </div>
//           </div>
//         </div>
//         <div className={styles.headerRight}>{getStatusBadge(status)}</div>
//       </div>

//       {/* Visitor Information Section */}
//       <div className={styles.section}>
//         <div className={styles.sectionHeader}>
//           <User size={20} />
//           <h2>Visitor Information</h2>
//         </div>
//         <div className={styles.sectionContent}>
//           <div className={styles.detailsGrid}>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Full Name</span>
//               <span className={styles.value}>{fullName || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Email</span>
//               <span className={styles.value}>{email || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Company</span>
//               <span className={styles.value}>{companyName || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Nationality</span>
//               <span className={styles.value}>{nationality || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>ID / Iqama</span>
//               <span className={styles.value}>{idIqama || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Contact Person</span>
//               <span className={styles.value}>{contactPerson || "-"}</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Visit Details Section */}
//       <div className={styles.section}>
//         <div className={styles.sectionHeader}>
//           <Calendar size={20} />
//           <h2>Visit Details</h2>
//         </div>
//         <div className={styles.sectionContent}>
//           <div className={styles.detailsGrid}>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Department</span>
//               <span className={styles.value}>{department?.name || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Staff</span>
//               <span className={styles.value}>{staff.name || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Reason of Visit</span>
//               <span className={styles.value}>{reasonOfVisit || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Visiting Areas</span>
//               <span className={styles.value}>{visitingAreas || "-"}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Visit Start</span>
//               <span className={styles.value}>{formatDate(visitStart)}</span>
//             </div>
//             <div className={styles.detailItem}>
//               <span className={styles.label}>Visit End</span>
//               <span className={styles.value}>{formatDate(visitEnd)}</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Vehicles Section */}
//       {vehicles && vehicles.length > 0 && (
//         <div className={styles.section}>
//           <div className={styles.sectionHeader}>
//             <Car size={20} />
//             <h2>Vehicles ({vehicles.length})</h2>
//           </div>
//           <div className={styles.sectionContent}>
//             {vehicles.map((vehicle, index) => (
//               <div key={vehicle._id || index} className={styles.vehicleCard}>
//                 {/* <div className={styles.vehicleHeader}>
//                   <span className={styles.vehicleNumber}>Vehicle {index + 1}</span>
//                 </div> */}
//                 <div className={styles.detailsGrid}>
//                   <div className={styles.detailItem}>
//                     <span className={styles.label}>Vehicle Name</span>
//                     <span className={styles.value}>{vehicle.name || "-"}</span>
//                   </div>
//                   <div className={styles.detailItem}>
//                     <span className={styles.label}>Model</span>
//                     <span className={styles.value}>{vehicle.model || "-"}</span>
//                   </div>
//                   <div className={styles.detailItem}>
//                     <span className={styles.label}>Color</span>
//                     <span className={styles.value}>{vehicle.color || "-"}</span>
//                   </div>
//                   <div className={styles.detailItem}>
//                     <span className={styles.label}>Plate No</span>
//                     <span className={styles.value}>{vehicle.plateNo || "-"}</span>
//                   </div>
//                   <div className={styles.detailItem}>
//                     <span className={styles.label}>Owner Name</span>
//                     <span className={styles.value}>{vehicle.ownerName || "-"}</span>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Documents Section */}
//       {documents && Object.values(documents).some((doc) => doc?.url || doc?.key) && (
//         <div className={styles.section}>
//           <div className={styles.sectionHeader}>
//             <FileText size={20} />
//             <h2>Documents</h2>
//           </div>
//           <div className={styles.sectionContent}>
//             <div className={styles.documentsGrid}>
//               {Object.entries(documents).map(([key, doc]) => {
//                 if (!doc?.url && !doc?.key) return null;
//                 return (
//                   <div key={key} className={styles.documentItem}>
//                     <FileText size={16} />
//                     <div className={styles.documentInfo}>
//                       <span className={styles.documentLabel}>
//                         {key
//                           .replace(/([A-Z])/g, " $1")
//                           .replace(/^./, (str) => str.toUpperCase())}
//                       </span>
//                       <a
//                         href={doc.url || doc.key}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className={styles.documentLink}
//                       >
//                         {doc.originalFileName || doc.key?.split("/").pop() || "View Document"}
//                       </a>
//                     </div>
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* QR Code Section */}
//       {qrCode?.url && (
//         <div className={styles.section}>
//           <div className={styles.sectionHeader}>
//             <QrCode size={20} />
//             <h2>Vehicle Entry Pass QR Code</h2>
//           </div>
//           <div className={styles.sectionContent}>
//             <div className={styles.qrCodeContainer}>
//               <img src={qrCode.url} alt="QR Code" className={styles.qrCodeImage} />
//               <p className={styles.qrCodeLabel}>Scan for Vehicle Entry Verification</p>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Scan History Section */}
//       {scanHistory && scanHistory.length > 0 && (
//         <div className={styles.section}>
//           <div className={styles.sectionHeader}>
//             <Clock size={20} />
//             <h2>Scan History</h2>
//           </div>
//           <div className={styles.sectionContent}>
//             <div className={styles.tableWrapper}>
//               <table className={styles.table}>
//                 <thead>
//                   <tr>
//                     <th>Scan Time</th>
//                     <th>Status Code</th>
//                     <th>Validity</th>
//                     <th>Reason</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {scanHistory.map((scan) => (
//                     <tr key={scan._id}>
//                       <td>{formatDate(scan.scanTime)}</td>
//                       <td>{scan.statusCode || "-"}</td>
//                       <td>
//                         {scan.isValid ? (
//                           <span className={styles.validBadge}>Valid</span>
//                         ) : (
//                           <span className={styles.invalidBadge}>Invalid</span>
//                         )}
//                       </td>
//                       <td>{scan.reason || "-"}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* System Info */}
//       <div className={styles.systemInfo}>
//         <div className={styles.systemInfoItem}>
//           <span className={styles.label}>Created At:</span>
//           <span className={styles.value}>{formatDate(createdAt)}</span>
//         </div>
//         <div className={styles.systemInfoItem}>
//           <span className={styles.label}>Last Updated:</span>
//           <span className={styles.value}>{formatDate(updatedAt)}</span>
//         </div>
//       </div>

//       {/* Action Buttons */}
//       <div className={styles.actions}>
//         {status === "pending" && (
//           <>
//             <button
//               className={`${styles.btn} ${styles.btnAccept}`}
//               disabled={updatingStatus}
//               onClick={() => updateStatus("accept", fullName)}
//             >
//               {updatingStatus ? (
//                 <div className={styles.btnSpinner}></div>
//               ) : (
//                 <>
//                   <CheckCircle size={18} />
//                   Accept Pass
//                 </>
//               )}
//             </button>

//             <button
//               className={`${styles.btn} ${styles.btnReject}`}
//               disabled={updatingStatus}
//               onClick={() => updateStatus("reject", fullName)}
//             >
//               {updatingStatus ? (
//                 <div className={styles.btnSpinner}></div>
//               ) : (
//                 <>
//                   <XCircle size={18} />
//                   Reject Pass
//                 </>
//               )}
//             </button>
//           </>
//         )}

//         {status === "accept" && (
//           <button
//             className={`${styles.btn} ${styles.btnPrimary}`}
//             disabled={sendingPass}
//             onClick={sendGatePass}
//           >
//             {sendingPass ? (
//               <div className={styles.btnSpinner}></div>
//             ) : (
//               <>
//                 <Mail size={18} />
//                 Send Gate Pass
//               </>
//             )}
//           </button>
//         )}

//         <button
//           className={`${styles.btn} ${styles.btnOutline}`}
//           onClick={() => navigate(-1)}
//         >
//           <ArrowLeft size={18} />
//           Back To List
//         </button>
//       </div>
//     </div>
//   );
// };

// export default VehicleGatePassDetails;

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import swal from "sweetalert";
import {
  User,
  Calendar,
  Car,
  FileText,
  QrCode,
  Clock,
  ArrowLeft,
  CheckCircle,
  XCircle,
  AlertCircle,
  Mail,
  Building,
  IdCard,
  Globe,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import styles from "./vehicleGatePassDetails.module.css";

const VehicleGatePassDetails = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const API = process.env.REACT_APP_API_URL;
  const AUTH_KEY = process.env.REACT_APP_AUTH_KEY;

  const [vehiclePass, setVehiclePass] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updatingStatus, setUpdatingStatus] = useState(false);
  const [sendingPass, setSendingPass] = useState(false);

  const formatDate = (date) => {
    if (!date) return "-";
    return new Date(date).toLocaleString("en-IN", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "accept":
        return (
          <div className={`${styles.badge} ${styles.badgeAccepted}`}>
            <CheckCircle size={16} />
            <span>{t("vehicleGatePassDetails.status.accepted")}</span>
          </div>
        );
      case "reject":
        return (
          <div className={`${styles.badge} ${styles.badgeRejected}`}>
            <XCircle size={16} />
            <span>{t("vehicleGatePassDetails.status.rejected")}</span>
          </div>
        );
      default:
        return (
          <div className={`${styles.badge} ${styles.badgePending}`}>
            <AlertCircle size={16} />
            <span>{t("vehicleGatePassDetails.status.pending")}</span>
          </div>
        );
    }
  };

  const fetchVehiclePass = async () => {
    try {
      const response = await fetch(`${API}vehicle-gate-pass-details/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          authkey: AUTH_KEY,
        },
      });
      const data = await response.json();
      if (response.ok && data?.data?.vehiclePass) {
        setVehiclePass(data.data.vehiclePass);
      } else {
        toast.error(t("vehicleGatePassDetails.error.fetchFailed"));
        navigate(-1);
      }
    } catch (error) {
      toast.error(t("vehicleGatePassDetails.error.fetchError"));
      navigate(-1);
    } finally {
      setLoading(false);
    }
  };

  // const updateStatus = async (action, fullName) => {
  //   const actionText =
  //     action === "accept"
  //       ? t("vehicleGatePassDetails.buttons.accept")
  //       : t("vehicleGatePassDetails.buttons.reject");

  //   const confirm = await swal({
  //     title: `${actionText} ${fullName}?`,
  //     text: t("vehicleGatePassDetails.confirm.text", { action: actionText.toLowerCase() }),
  //     icon: action === "accept" ? "success" : "error",
  //     buttons: [t("vehicleGatePassDetails.confirm.cancel"), actionText],
  //     dangerMode: action === "reject",
  //   });

  //   if (!confirm) return;

  //   try {
  //     setUpdatingStatus(true);
  //     const response = await fetch(`${API}update-vehicle-gate-pass-status/${vehiclePass._id}`, {
  //       method: "PUT",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         authkey: AUTH_KEY,
  //       },
  //       body: JSON.stringify({ status: action, lang: localStorage.getItem("lang") }),
  //     });
  //     const data = await response.json();
  //     if (response.ok) {
  //       toast.success(
  //         action === "accept"
  //           ? t("vehicleGatePassDetails.toast.acceptedSuccess")
  //           : t("vehicleGatePassDetails.toast.rejectedSuccess"),
  //       );
  //       setVehiclePass((prev) => ({ ...prev, status: action }));
  //     } else {
  //       toast.error(data.message || t("vehicleGatePassDetails.toast.updateError"));
  //     }
  //   } catch (error) {
  //     toast.error(t("vehicleGatePassDetails.toast.updateError"));
  //   } finally {
  //     setUpdatingStatus(false);
  //   }
  // };

  // const sendGatePass = async () => {
  //   try {
  //     setSendingPass(true);
  //     const response = await fetch(`${API}send-vehicle-gate-pass/${vehiclePass._id}`, {
  //       method: "POST",
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         authkey: AUTH_KEY,
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ lang: localStorage.getItem("lang") }),
  //     });
  //     const data = await response.json();
  //     if (response.ok) {
  //       toast.success(t("vehicleGatePassDetails.toast.sentSuccess"));
  //     } else {
  //       toast.error(data.message || t("vehicleGatePassDetails.toast.sentError"));
  //     }
  //   } catch (error) {
  //     toast.error(t("vehicleGatePassDetails.toast.sentError"));
  //   } finally {
  //     setSendingPass(false);
  //   }
  // };

  const updateStatus = async (action, fullName) => {
    if (updatingStatus) return;

    // STEP 1: Language selection
    const langChoice = await swal({
      title: t("vehicleGatePassDetails.chooseLanguageTitle"),
      text: t("vehicleGatePassDetails.chooseLanguageText"),
      icon: "info",
      buttons: {
        en: {
          text: t("Common.languageEnglish"),
          value: "en",
        },
        ar: {
          text: t("Common.languageArabic"),
          value: "ar",
        },
      },
    });

    if (!langChoice) return;

    const actionText =
      action === "accept"
        ? t("vehicleGatePassDetails.buttons.accept")
        : t("vehicleGatePassDetails.buttons.reject");

    // STEP 2: Confirmation
    const confirm = await swal({
      title: `${actionText} ${fullName}?`,
      text: t("vehicleGatePassDetails.confirm.text", {
        action: actionText.toLowerCase(),
      }),
      icon: action === "accept" ? "success" : "error",
      buttons: [t("vehicleGatePassDetails.confirm.cancel"), actionText],
      dangerMode: action === "reject",
    });

    if (!confirm) return;

    try {
      setUpdatingStatus(true);

      const response = await fetch(`${API}update-vehicle-gate-pass-status/${vehiclePass._id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          authkey: AUTH_KEY,
        },
        body: JSON.stringify({
          status: action,
          lang: langChoice, // ✅ explicit language
        }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success(
          action === "accept"
            ? t("vehicleGatePassDetails.toast.acceptedSuccess")
            : t("vehicleGatePassDetails.toast.rejectedSuccess"),
        );

        setVehiclePass((prev) => ({
          ...prev,
          status: action,
        }));
      } else {
        toast.error(data.message || t("vehicleGatePassDetails.toast.updateError"));
      }
    } catch (error) {
      toast.error(t("vehicleGatePassDetails.toast.updateError"));
    } finally {
      setUpdatingStatus(false);
    }
  };

  const sendGatePass = async () => {
    const langChoice = await swal({
      title: t("vehicleGatePassDetails.chooseLanguageTitle"),
      text: t("vehicleGatePassDetails.chooseLanguageText"),
      icon: "info",
      buttons: {
        en: {
          text: t("Common.languageEnglish"),
          value: "en",
        },
        ar: {
          text: t("Common.languageArabic"),
          value: "ar",
        },
      },
    });

    if (!langChoice) return;

    try {
      setSendingPass(true);
      const response = await fetch(`${API}send-vehicle-gate-pass/${vehiclePass._id}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          authkey: AUTH_KEY,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ lang: langChoice }),
      });

      const data = await response.json();
      if (response.ok) {
        toast.success(t("vehicleGatePassDetails.toast.sentSuccess"));
      } else {
        toast.error(data.message || t("vehicleGatePassDetails.toast.sentError"));
      }
    } catch (error) {
      toast.error(t("vehicleGatePassDetails.toast.sentError"));
    } finally {
      setSendingPass(false);
    }
  };

  useEffect(() => {
    fetchVehiclePass();
  }, [id, updatingStatus]);

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.spinner}></div>
      </div>
    );
  }

  if (!vehiclePass) {
    return (
      <div className={styles.noData}>
        <p>{t("vehicleGatePassDetails.noData")}</p>
      </div>
    );
  }

  const {
    fullName,
    email,
    companyName,
    nationality,
    idIqama,
    vehicles,
    reasonOfVisit,
    visitStart,
    visitEnd,
    visitingAreas,
    department,
    staff,
    contactPerson,
    documents,
    qrCode,
    status,
    scanHistory,
    createdAt,
    updatedAt,
    visitorId,
    staff_status,
  } = vehiclePass;

  return (
    <div className={styles.container}>
      {/* Header Section */}
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <div className={styles.avatar}>{fullName ? fullName.charAt(0).toUpperCase() : "V"}</div>
          <div className={styles.headerInfo}>
            <h1 className={styles.title}>
              {fullName || t("vehicleGatePassDetails.header.defaultTitle")}
            </h1>
            <div className={styles.metaInfo}>
              <span className={styles.metaItem}>
                <IdCard size={14} />
                {visitorId || "N/A"}
              </span>
              <span className={styles.metaItem}>
                <Building size={14} />
                {companyName || "N/A"}
              </span>
            </div>
          </div>
        </div>
        <div className={styles.headerRight}>{getStatusBadge(status)}</div>
      </div>

      {/* Visitor Information Section */}
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <User size={20} />
          <h2>{t("vehicleGatePassDetails.visitorInfo.title")}</h2>
        </div>
        <div className={styles.sectionContent}>
          <div className={styles.detailsGrid}>
            {[
              ["fullName", fullName],
              ["email", email],
              ["company", companyName],
              ["nationality", nationality],
              ["idIqama", idIqama],
              ["contactPerson", contactPerson],
            ].map(([key, value]) => (
              <div className={styles.detailItem} key={key}>
                <span className={styles.label}>
                  {t(`vehicleGatePassDetails.visitorInfo.labels.${key}`)}
                </span>
                <span className={styles.value}>{value || "-"}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Visit Details Section */}
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <Calendar size={20} />
          <h2>{t("vehicleGatePassDetails.visitDetails.title")}</h2>
        </div>
        <div className={styles.sectionContent}>
          <div className={styles.detailsGrid}>
            {[
              ["department", department?.name],
              ["staff", staff.name],
              ["reasonOfVisit", reasonOfVisit],
              ["visitingAreas", visitingAreas],
              ["visitStart", formatDate(visitStart)],
              ["visitEnd", formatDate(visitEnd)],
            ].map(([key, value]) => (
              <div className={styles.detailItem} key={key}>
                <span className={styles.label}>
                  {t(`vehicleGatePassDetails.visitDetails.labels.${key}`)}
                </span>
                <span className={styles.value}>{value || "-"}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Vehicles Section */}
      {vehicles && vehicles.length > 0 && (
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <Car size={20} />
            <h2>{t("vehicleGatePassDetails.vehicles.title", { count: vehicles.length })}</h2>
          </div>
          <div className={styles.sectionContent}>
            {vehicles.map((vehicle, index) => (
              <div key={vehicle._id || index} className={styles.vehicleCard}>
                <div className={styles.detailsGrid}>
                  {[
                    ["name", vehicle.name],
                    ["model", vehicle.model],
                    ["color", vehicle.color],
                    ["plateNo", vehicle.plateNo],
                    ["ownerName", vehicle.ownerName],
                  ].map(([key, value]) => (
                    <div className={styles.detailItem} key={key}>
                      <span className={styles.label}>
                        {t(`vehicleGatePassDetails.vehicles.labels.${key}`)}
                      </span>
                      <span className={styles.value}>{value || "-"}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Documents Section */}
      {documents && Object.values(documents).some((doc) => doc?.url || doc?.key) && (
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <FileText size={20} />
            <h2>{t("vehicleGatePassDetails.documents.title")}</h2>
          </div>
          <div className={styles.sectionContent}>
            <div className={styles.documentsGrid}>
              {Object.entries(documents).map(([key, doc]) => {
                console.log(key);

                if (!doc?.url && !doc?.key) return null;
                return (
                  <div key={key} className={styles.documentItem}>
                    <FileText size={16} />
                    <div className={styles.documentInfo}>
                      <span className={styles.documentLabel}>
                        {t(`vehicleGatePassDetails.documents.labels.${key}`, { defaultLabel: key })}
                      </span>
                      <a
                        href={doc.url || doc.key}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.documentLink}
                      >
                        {doc.originalFileName ||
                          doc.key?.split("/").pop() ||
                          t("vehicleGatePassDetails.documents.viewDoc")}
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* QR Code Section */}
      {qrCode?.url && (
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <QrCode size={20} />
            <h2>{t("vehicleGatePassDetails.qr.title")}</h2>
          </div>
          <div className={styles.sectionContent}>
            <div className={styles.qrCodeContainer}>
              <img
                src={qrCode.url}
                alt={t("vehicleGatePassDetails.qr.alt")}
                className={styles.qrCodeImage}
              />
              <p className={styles.qrCodeLabel}>{t("vehicleGatePassDetails.qr.scanText")}</p>
            </div>
          </div>
        </div>
      )}

      {/* Scan History Section */}
      {scanHistory && scanHistory.length > 0 && (
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <Clock size={20} />
            <h2>{t("vehicleGatePassDetails.scanHistory.title")}</h2>
          </div>
          <div className={styles.sectionContent}>
            <div className={styles.tableWrapper}>
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th>{t("vehicleGatePassDetails.scanHistory.labels.scanTime")}</th>
                    <th>{t("vehicleGatePassDetails.scanHistory.labels.statusCode")}</th>
                    <th>{t("vehicleGatePassDetails.scanHistory.labels.validity")}</th>
                    <th>{t("vehicleGatePassDetails.scanHistory.labels.reason")}</th>
                  </tr>
                </thead>
                <tbody>
                  {scanHistory.map((scan) => (
                    <tr key={scan._id}>
                      <td>{formatDate(scan.scanTime)}</td>
                      <td>{scan.statusCode || "-"}</td>
                      <td>
                        {scan.isValid ? (
                          <span className={styles.validBadge}>
                            {t("vehicleGatePassDetails.scanHistory.valid")}
                          </span>
                        ) : (
                          <span className={styles.invalidBadge}>
                            {t("vehicleGatePassDetails.scanHistory.invalid")}
                          </span>
                        )}
                      </td>
                      <td>{scan.reason || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* System Info */}
      <div className={styles.systemInfo}>
        <div className={styles.systemInfoItem}>
          <span className={styles.label}>{t("vehicleGatePassDetails.system.createdAt")}</span>
          <span className={styles.value}>{formatDate(createdAt)}</span>
        </div>
        <div className={styles.systemInfoItem}>
          <span className={styles.label}>{t("vehicleGatePassDetails.system.updatedAt")}</span>
          <span className={styles.value}>{formatDate(updatedAt)}</span>
        </div>
      </div>

      {/* Action Buttons */}
      <div className={styles.actions}>
        {status === "pending" && staff_status !== "reject" && (
          <>
            <button
              className={`${styles.btn} ${styles.btnAccept}`}
              disabled={updatingStatus}
              onClick={() => updateStatus("accept", fullName)}
            >
              {updatingStatus ? (
                <div className={styles.btnSpinner}></div>
              ) : (
                <>
                  <CheckCircle size={18} />
                  {t("vehicleGatePassDetails.buttons.acceptPass")}
                </>
              )}
            </button>

            <button
              className={`${styles.btn} ${styles.btnReject}`}
              disabled={updatingStatus}
              onClick={() => updateStatus("reject", fullName)}
            >
              {updatingStatus ? (
                <div className={styles.btnSpinner}></div>
              ) : (
                <>
                  <XCircle size={18} />
                  {t("vehicleGatePassDetails.buttons.rejectPass")}
                </>
              )}
            </button>
          </>
        )}

        {status === "accept" && (
          <button
            className={`${styles.btn} ${styles.btnPrimary}`}
            disabled={sendingPass}
            onClick={sendGatePass}
          >
            {sendingPass ? (
              <div className={styles.btnSpinner}></div>
            ) : (
              <>
                <Mail size={18} />
                {t("vehicleGatePassDetails.buttons.sendGatePass")}
              </>
            )}
          </button>
        )}

        <button className={`${styles.btn} ${styles.btnOutline}`} onClick={() => navigate(-1)}>
          <ArrowLeft size={18} />
          {t("vehicleGatePassDetails.buttons.backToList")}
        </button>
      </div>
    </div>
  );
};

export default VehicleGatePassDetails;
